const calculateHomologateScore = (baseScore: number, maximumScore: number, maxScorePerChapter: number) => {
  return Math.floor((baseScore * maximumScore) / maxScorePerChapter)
}

export default calculateHomologateScore
